'use client'

import { IconDocument } from '@macarongfactory/web-icons'
import { Text } from '@macarongfactory/web-ui'

const ReviewEmpty = () => (
  <div className='flex flex-col items-center justify-center gap-dimension-x3 py-dimension-x12'>
    <IconDocument
      width={56}
      height={56}
      className='text-foreground-neutral-disabled'
    />
    <Text variant='body-1-medium' color='text-foreground-neutral-alternative'>
      아직 리뷰가 없어요
    </Text>
  </div>
)

export default ReviewEmpty
